import React from 'react'
import { string, any, bool } from 'prop-types'

import { DEFAULT_VARIANT_NAME } from 'shared/consts/optimizely'
import { getExperiment } from './helpers'

const Experiment = ({
  children,
  name,
  classNames,
  preventActivation,
  component: Component
}) => {
  const experiment = getExperiment(name)

  if (!experiment.variant) {
    experiment.variant = DEFAULT_VARIANT_NAME
  }

  const props = {
    className: classNames,
    'data-experiment': name,
    'data-prevent-activation': preventActivation
  }

  // children is callback fn case
  if (typeof children === 'function') {
    return <Component {...props}>{children(experiment)}</Component>
  }

  let match

  React.Children.forEach(children, child => {
    if (match || !React.isValidElement(child)) {
      return
    }

    if (child.props.name) {
      if (experiment.variant === child.props.name) {
        match = child
      }
    }
  })

  const firstChild = children?.[0]
  if (!match && firstChild && React.isValidElement(firstChild)) {
    match = firstChild
  }

  return (
    <Component {...props}>
      {match
        ? React.cloneElement(match, { variables: experiment.variables })
        : null}
    </Component>
  )
}

Experiment.propTypes = {
  name: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  children: any.isRequired,
  classNames: string,
  preventActivation: bool,
  component: string
}

Experiment.defaultProps = {
  classNames: null,
  preventActivation: undefined,
  component: 'div'
}

export default Experiment
